export default {
    data() {
        return {
            sourceCode: '', // 源目标code
            targetCode: '', // 目标code
            dragConfig: {
                // 是否只在特定单元格内才能拖拽，默认为false（保持向后兼容）
                dragOnlyInCell: false,
                // 拖拽单元格的类名，当dragOnlyInCell为true时使用
                dragCellClass: 'drag-cell'
            }
        };
    },
    methods: {
        customRow(record, index) {
            return {
                props: {
                    // draggable: 'true'
                },
                style: {
                    cursor: 'pointer'
                },
                on: {
                    // 鼠标移入
                    mouseenter: event => {
                        const ev = event || window.event; // 兼容IE
                        // 如果配置了只在单元格内拖拽，则不在这里设置draggable
                        if (!this.dragConfig.dragOnlyInCell) {
                            ev.target.draggable = true; // 让你要拖动的行可以拖动，默认不可以
                        }
                    },
                    // 开始拖拽
                    dragstart: event => {
                        const ev = event || window.event; // 兼容IE
                        ev.stopPropagation(); // 阻止冒泡
                        // 得到源目标数据序号
                        this.sourceCode = record.id;
                    },
                    // 拖动元素经过的元素
                    dragover: event => {
                        // 兼容 IE
                        const ev = event || window.event;
                        // 阻止默认行为
                        ev.preventDefault();
                    },
                    // 拖动到达目标元素
                    dragenter: event => {
                        const ev = event || window.event;
                        ev.preventDefault();
                        // 设置拖动高亮效果
                        const list = document.getElementsByClassName('ant-table-row');
                        const node = document.getElementsByClassName('target');
                        if (node.length) {
                            node[0].classList.remove('target');
                        }

                        list[index].classList.add('target');
                    },
                    // 鼠标松开
                    drop: event => {
                        const ev = event || window.event; // 兼容IE
                        ev.stopPropagation(); // 阻止冒泡
                        // 得到目标数据序号
                        this.targetCode = record.id;
                        // 取消高亮效果
                        const node = document.getElementsByClassName('target');
                        if (node.length) {
                            node[0].classList.remove('target');
                        }
                        // 在备份数组上执行排序操作
                        const list = this.dataSource.slice();

                        // 2. 通过code找到拖拽终点index，把备份的起始数据插入这个位置
                        const targetIndex = list.findIndex(item => item.id === this.targetCode);

                        // 1. 通过code找到拖拽起始数据，备份它，并从数组中删除
                        const sourceIndex = list.findIndex(item => item.id === this.sourceCode);

                        if (targetIndex == -1 || targetIndex == sourceIndex) {
                            return false;
                        }

                        const sourceItem = list[sourceIndex];
                        list.splice(sourceIndex, 1);

                        const targetItem = list[targetIndex];

                        if (sourceIndex === targetIndex) {
                            list.splice(targetIndex + 1, 0, sourceItem);
                        } else {
                            list.splice(targetIndex, 0, sourceItem);
                        }
                        // 排序好的数组应用到响应式数据中
                        this.dataSource = list;

                        // 调用拖拽成功回调
                        if (typeof this.dragSuccess === 'function') {
                            // 注意：这里的sourceIndex和targetIndex是排序前的索引
                            // 在排序后，被拖拽的数据现在在targetIndex位置
                            this.dragSuccess({
                                sourceIndex,
                                targetIndex
                            });
                        } else {
                            console.warn('dragSuccess拖拽成功方法不存在');
                        }
                    }
                }
            };
        },
        // 设置拖拽配置
        setDragConfig(config) {
            this.dragConfig = { ...this.dragConfig, ...config };
        },
        // 为拖拽单元格添加拖拽事件
        setupDragCell() {
            if (!this.dragConfig.dragOnlyInCell) return;

            // 使用nextTick确保DOM已经渲染
            this.$nextTick(() => {
                const dragCells = document.querySelectorAll(`.${this.dragConfig.dragCellClass}`);
                dragCells.forEach(cell => {
                    cell.addEventListener('mouseenter', event => {
                        const ev = event || window.event;
                        // 找到当前行并设置draggable
                        const row = ev.target.closest('.ant-table-row');
                        if (row) {
                            row.draggable = true;
                        }
                    });

                    cell.addEventListener('mouseleave', event => {
                        const ev = event || window.event;
                        // 检查鼠标是否真的离开了整个拖拽区域
                        const relatedTarget = ev.relatedTarget;
                        if (!relatedTarget || !cell.contains(relatedTarget)) {
                            const row = ev.target.closest('.ant-table-row');
                            if (row) {
                                row.draggable = false;
                            }
                        }
                    });
                });
            });
        }
    }
};
